<div class="row align-items-center m-b-10">
  <div class="col-sm-12 col-lg-8">
    <div class="d-flex align-items-center flexmob">
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex">

        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Statement of Financial Activities (SoFA)
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            <!--Hope Foundation - 2023/24-->
            {{FinancialYear}}
          </h5>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-lg-4 text-right" *ngIf="ispreview">
    <!--(click)="PreviewSOFA(modal)"-->
    <!--(click)="this.ExportasPDFandIXBRL('ExportasPDF', 'ForPDFviwer',template)"-->
    <div class="d-flex justify-content-end">
      <div class="p-8" style="background-color: #fff; border-radius:10px;">
        <button mat-flat-button class="bg-none preview m-r-10" (click)="PreviewSOFA(modal)" [disabled]="!UserRoleAccess?.m1ExportorDownload" [ngClass]="{
    'bg-none text-dark': UserRoleAccess?.m1ExportorDownload,
    'bg-light text-muted cursor-not-allowed': !UserRoleAccess?.m1ExportorDownload
  }">
          <div class="bg-none d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="eye"></i-tabler>Preview
          </div>
        </button>
        <button mat-flat-button (click)="sendMailTemplate(emailtemplate)" class="bg-none" [disabled]="!UserRoleAccess?.m1SendMail">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-0" name="mail"></i-tabler> <!--Send Mail-->
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->



<div class="">
  <!-- <form [formGroup]="StatementofFinancialActivitiesForm">-->
  <mat-card class="m-t-14" style="border-radius: 6px;">
    <mat-card-content class="p-0">
      <div class="table-responsive shadow-lg" style="height: 650px; border-radius: 6px; border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <table mat-table [dataSource]="transactions" class="w-100">

          <ng-container matColumnDef="activity_Name">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 ">
              Recommended categories by activity
            </th>
            <td mat-cell *matCellDef="let transaction">
              <div class="d-flex align-items-center gap-12 " style="width: 280px; white-space: normal;">
                <span class="f-s-14 f-w-400 p-l-20">{{ transaction.activity_Name }} </span>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef class="f-w-600 f-s-14">
              Total
            </td>
          </ng-container>

          <ng-container matColumnDef="sofa_NotesID">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 d-none">
              Guidance Note
            </th>
            <td mat-cell *matCellDef="let transaction" class="d-none">
              {{ transaction.sofa_NotesID}}
            </td>
            <td mat-footer-cell *matFooterCellDef class="d-none">
              SA7
            </td>
          </ng-container>

          <ng-container matColumnDef="unrestrictedFunds">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Unrestricted funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <!-- @if((transaction.activity_Name == 'Extraordinary items') || (transaction.activity_Name ==  'Transfers between funds') || (transaction.activity_Name ==  'Total funds brought forward')){
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="number" [(ngModel)]="transaction.unrestrictedFunds" [ngModelOptions]="{standalone: true}" (input)="unrestrictedFundsCalculation(transaction.activity_Name, transaction.unrestrictedFunds)" />
              </mat-form-field>
              } @else  {-->
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="text" [value]="transaction.unrestricted_Funds " disabled />
              </mat-form-field>
              <!-- }-->
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ transaction.unrestrictedFunds}}
            </td>
          </ng-container>

          <ng-container matColumnDef="restricteIncome">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Restricted funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <!-- @if((transaction.activity_Name == 'Extraordinary items') || (transaction.activity_Name ==  'Transfers between funds') || (transaction.activity_Name ==  'Total funds brought forward')){
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="number" [(ngModel)]="transaction.restricteIncome" [ngModelOptions]="{standalone: true}" (input)="restricteIncomeCalculation(transaction.activity_Name, transaction.restricteIncome)" />

              </mat-form-field>
              } @else  {-->
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="text" [value]=" transaction.restricted_Income_Funds" disabled />
              </mat-form-field>
              <!--}-->
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ transaction.restricteIncome }}
            </td>
          </ng-container>

          <ng-container matColumnDef="endowmentFunds">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Endowment funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <!--@if((transaction.activity_Name == 'Extraordinary items') || (transaction.activity_Name ==  'Transfers between funds') || (transaction.activity_Name ==  'Total funds brought forward')){
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="number" [(ngModel)]="transaction.endowmentFunds" [ngModelOptions]="{standalone: true}" (input)="endowmentFundsCalculation(transaction.activity_Name, transaction.endowmentFunds)" />
              </mat-form-field>
              } @else  {-->
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="text" [value]=" transaction.endowment_Funds" disabled />
              </mat-form-field>
              <!-- }-->
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ transaction.endowmentFunds }}
            </td>
          </ng-container>

          <ng-container matColumnDef="total_Funds">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Total funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction" class="text-right">
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="text" [value]=" transaction.total_Funds" disabled />
              </mat-form-field>
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ transaction.total_Funds  }}
            </td>
          </ng-container>

          <ng-container matColumnDef="prior_Year_Funds">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14 text-right">
              Prior year funds (£)
            </th>
            <td mat-cell *matCellDef="let transaction ; let i = index;" class="text-right">
              <!--@if((transaction.activity_Name == 'Extraordinary items') || (transaction.activity_Name ==  'Transfers between funds') || (transaction.activity_Name ==  'Total funds brought forward')){
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="number" [(ngModel)]="transaction.prior_Year_Funds" [ngModelOptions]="{standalone: true}" (blur)="checkValue(transaction, transaction.prior_Year_Funds, index,track)" />
              </mat-form-field>
              }
              @else{-->
              <mat-form-field appearance="outline" class="w30">
                <input matInput placeholder="" type="text" [value]=" transaction.prior_Year_Funds" disabled />
              </mat-form-field>
              <!--}-->
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{transaction.prior_Year_Funds}}
            </td>
          </ng-container>

          <ng-container matColumnDef="expence-description">
            <td mat-cell *matCellDef="let transaction" colspan="7" class="f-w-600 f-s-14 expence-row">
              {{transaction.activity_Name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="sub">
            <td mat-cell *matCellDef="let transaction" colspan="7" class="f-w-600 f-s-14 expence-row">
              {{transaction.activity_Name}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Total">
            <td mat-cell *matCellDef="let transaction" class="f-w-600 f-s-14 expence-row">
              {{transaction.activity_Name}}
            </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns2;sticky:true" class="example-first-header-row" style=" text-wrap-mode: nowrap;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2; when: isDataRow;"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expence-description']; when: isHeaderRow" class=" f-s-20  headerdark" style="background: rgb(234 234 234 / 0.29)"></tr>
          <tr mat-row *matRowDef="let row; columns: ['sub']; when: isSubHeaderRow" class=" f-s-16  " style="background: rgb(234 234 234 / 0.28);"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2; when: isfooterrow" class=" f-w-600  totalvalue"></tr>
        </table>
      </div>



      <!--<hr class="m-t-24" style="opacity:0.2" />-->
      <div class="row p-16" style="">
        <div class="col-6 col-sm-6 col-md-4 col-4">
          <button mat-flat-button color="primary" class="bg-warning text-end" (click)="SoFABack()">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
            </div>
          </button>
        </div>
        <div class="col-6 col-sm-6 col-md-8" align="right">
          <!--@if(showSaveBtn == true){
          <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveStatementOfActivities('true','Update')">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Update &amp; Next</span>
            </div>
          </button>
          }
          @else{-->
          <!--<button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10" (click)="SaveStatementOfActivities('false')">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Save as Draft</span>
            </div>
          </button>-->
          <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveStatementOfActivities('true','Save')">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white hidemenutext">  Next</span>
            </div>
          </button>
          <!--  }-->
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <!--</form>-->

</div>



<!--<div class="table-responsive">
<table mat-table [dataSource]="transactions" class="w-100">-->
<!-- Item Column -->
<!--<ng-container matColumnDef="item">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Recommended categories by activity
      </th>
      <td mat-cell *matCellDef="let transaction">
        <div class="d-flex align-items-center gap-12">

          <span class="f-s-16 f-w-600">{{ transaction.item }} </span>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef class="f-w-600 f-s-16">
        Total
      </td>
    </ng-container>

    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Guidance Note
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.cost}}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        SA7
      </td>
    </ng-container>

    <ng-container matColumnDef="Unrestrictedfunds">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Unrestricted funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.Unrestrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ getUnrestrictedfundsocst() | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Restricted income funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Restricted income funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Endowment funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Endowment funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Total funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Total funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>


    <ng-container matColumnDef="Prior year funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Prior year funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>


    <ng-container matColumnDef="income">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14" colspan="7">
        Income (Note 3)<br />Income and endowments from:
      </th>
    </ng-container>

    <ng-container matColumnDef="expenditure">
      <th mat-header-cell *matFooterCellDef class="f-w-600 f-s-14" colspan="7">
        Expenditure (Note 6)
      </th>
    </ng-container>



    <ng-container matColumnDef="item">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Recommended categories by activity
      </th>
      <td mat-cell *matCellDef="let transaction2">
        <div class="d-flex align-items-center gap-12">

          <span class="f-s-16 f-w-600">{{ transaction2.item }} </span>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef class="f-w-600 f-s-16">
        Total
      </td>
    </ng-container>

    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Guidance Note
      </th>
      <td mat-cell *matCellDef="let transaction2">
        {{ transaction2.cost}}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        SA7
      </td>
    </ng-container>

    <ng-container matColumnDef="Unrestrictedfunds">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Unrestricted funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction2">
        {{ transaction2.Unrestrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ getUnrestrictedfundsocst() | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Restricted income funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Restricted income funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction2">
        {{ transaction2.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Endowment funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Endowment funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction2">
        {{ transaction2.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Total funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Total funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction2">
        {{ transaction2.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>


    <ng-container matColumnDef="Prior year funds (£)">
      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-16">
        Prior year funds (£)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.restrictedfunds | currency }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ restrictedfunds() | currency }}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns2" class="example-first-header-row"></tr>
    <tr mat-header-row *matHeaderRowDef="['income']"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>

    <tr mat-footer-row *matFooterRowDef="displayedColumns2" class="example-first-footer-row"></tr>


    <tr mat-footer-row *matFooterRowDef="['expenditure']" class="example-second-footer-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns3"></tr>

    <tr mat-footer-row *matFooterRowDef="displayedColumns3" class="example-first-footer-row"></tr>
  </table>
</div>-->
<div class="spinner-container" *ngIf="ShowSpinner">
  <mat-spinner></mat-spinner>
</div>

<ng-template #modal>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-20 sofaPreview">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Statement of Financial Activities Report</span></b>
          <button class="btn-close-dialog" mat-dialog-close>
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;">
        <div class="col-lg-12" style="height:750px;">
          <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #emailtemplate>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-14 p-b-0 sofaSendMail">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Send Mail</span></b>
          <button class="btn-close-dialog" (click)="cenceltemplete()">
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;">
        <div class="col-lg-12">
          <div class="p-y-16 b-t-1" style="overflow: hidden;" [formGroup]="SOFAform">

            <div class="col-lg-12" style=" padding: 20px; border-radius: 10px;">
              <div class="row align-items-center m-b-8">
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">From</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="40" formControlName="from" value="example@mail.com" [disabled]="true" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">To</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="100" formControlName="to" value="example@mail.com" />
                      <mat-error *ngIf="SOFAform.get('to')?.hasError('required')">
                        Email is required
                      </mat-error>
                      <mat-error *ngIf="SOFAform.get('to')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="d-flex align-items-center mb-0">
                    <mat-checkbox class="example-margin" (change)="SOFAformmailtoCC()" formControlName="ccCheckbox"></mat-checkbox>
                    <label class="f-s-14 f-w-600 m-0 p-0">CC/BCC</label>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="ifCCorBCCSOFA">
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">CC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="cc" maxlength="100" />
                      <mat-error *ngIf="SOFAform.get('cc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">BCC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="bcc" maxlength="100" />
                      <mat-error *ngIf="SOFAform.get('bcc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">Subject</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="Welcome to Charity Accounts Software" formControlName="subject" />
                      <mat-error *ngIf="SOFAform.get('subject')?.hasError('required')">
                        Subject is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-14 p-x-0">
              <div class="local-editor NgxEditor__Wrapper" style="height: 300px;">
                <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor1" [placeholder]="'Type here...'" formControlName="Body"></ngx-editor>
              </div>
            </mat-card-content>

            <hr class="m-t-24" style="opacity:0.2" />
            <div class="row p-t-16 p-b-0">
              <div class="col-sm-12 col-md-12 text-right">
                <button mat-flat-button type="submit" color="primary" class="bg-success rounded-5 m-r-10" (click)="sendmail()" [disabled]="isBodyEmpty(SOFAform)">
                  <div class="d-flex">
                    <span class="f-s-14 text-dark"> Send </span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-white border-light b-1 text-end" (click)="cenceltemplete()">
                  <div class="d-flex text-black">
                    <span class="f-s-12 text-black"> Cancel </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<ng-template #template>
  <div class="m-20">
    <!--<div class="b-b-1 p-b-10">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <mat-card-title class="mat-mdc-card-title">
            <h4 class="f-s-16 f-w-600 d-block m-b-0 heading">
              Final Accounts Preview
            </h4>
            <p class="f-s-14 f-w-400 m-y-4">
              Preview of complete accounts package
            </p>
          </mat-card-title>
        </div>
        <div>
          <button class="text-center btn-close-dialog" (click)="closeModalPreview()" style="transform:scale(0.8)">
            <i-tabler name="X" class=""></i-tabler>
          </button>
        </div>
      </div>
    </div>-->
    <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
      <div class="col d-flex justify-content-between align-items-center">
        <b><span>Statement of Financial Activities Report</span></b>
        <button class="btn-close-dialog" mat-dialog-close>
          <i-tabler name="X"></i-tabler>
        </button>
      </div>
    </div>
    <!-- PDF Viewer -->
    <div class="row" style="margin-left: 0; margin-right: 0;">
      <div class="col-lg-12" style="height:750px;">
        <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
      </div>
    </div>
    <!--<div class="row b-t-1 p-t-12">
      <div class="col-lg-12 text-right">
        <button mat-flat-button color="primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="printer"></i-tabler> Print
          </div>
        </button>
      </div>
    </div>-->
  </div>
</ng-template>
